import React from 'react';
import { Box } from 'rebass';
import IconLink, { IconLinkProps } from '../Icon/IconLink';
import { PortalWithState } from 'react-portal';
import UserMenu from './UserMenu';

const UserLink = (props: IconLinkProps): JSX.Element => {
  return (
    <PortalWithState closeOnOutsideClick closeOnEsc>
      {({ openPortal, closePortal, portal, isOpen }) => (
        <>
          <IconLink
            {...(props as any)}
            icon="person"
            iconAtEnd
            isDark
            onClick={isOpen ? closePortal : openPortal}
          />
          {portal(
            <Box
              sx={{
                position: 'fixed',
                top: 50,
                right: 0,
                bg: 'navbar',
                boxShadow: 'menu',
                zIndex: 30,
              }}
            >
              <UserMenu />
            </Box>
          )}
        </>
      )}
    </PortalWithState>
  );
};

export default UserLink;
